import { classNames } from "common/functions";
import PropTypes from "prop-types";

/**
 * vendor
 */

/** ========== */

const Breadcrumbs = ({ data, color, hoverColor, lastColor, wrapper }) => {
  const breadcrumbs = JSON.parse(
    JSON.stringify(data)
      .split(process.env.NEXT_PUBLIC_PRODUCTION_HOME_URL)
      .join(process.env.NEXT_PUBLIC_HOME_URL)
  );
  return (
    <div {...wrapper}>
      <div className="flex flex-wrap items-center justify-start">
        {breadcrumbs.map((item, index) => {
          let last = index + 1 === breadcrumbs.length;
          return (
            <div className="font-bold" key={index}>
              {!last ? (
                <>
                  <a
                    href={item?.url}
                    className={classNames(
                      "inline-block pr-2",
                      color,
                      hoverColor
                    )}
                  >
                    {item?.title}
                  </a>
                  <span className={`inline-block  ${color}  pr-2`}>/</span>
                </>
              ) : (
                <span className={`text-oxfordBlue inline-block  ${lastColor}`}>
                  {item?.title}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  items: PropTypes.array,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  lastColor: PropTypes.string,
};

Breadcrumbs.defaultProps = {
  items: [],
  color: "text-gleads-base",
  hoverColor: "hover:text-gleads-oxfordBlue-500",
  lastColor: "",
};

/** ========== */
